export default {"src":"/_next/static/media/icon-close.7bc9eb7b.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};